import { createFileRoute } from "@tanstack/react-router";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/dispense")({
  beforeLoad: requirePerm("dispense.view"),
  component: () => <PendingSurface titleKey="nav.dispense" />,
});
